import { Action, createReducer, on } from '@ngrx/store';

import { Schedule } from 'src/app/model/schedule';
import * as ScheduleActions from './schedule.actions';

export interface State {
    schedulesLoading: boolean;
    schedules: Schedule[];
    scheduleAdded: boolean;
    scheduleAdding: boolean;
    scheduleEditing: boolean;
    scheduleEdited: boolean;
}
export const initialState: State = {
    schedulesLoading: false,
    schedules: [],
    scheduleAdded: false,
    scheduleAdding: false,
    scheduleEditing: false,
    scheduleEdited: false,
};

const scheduleReducer = createReducer(
    initialState,
    on(ScheduleActions.getSchedules, (state) => ({ ...state, sceneriesLoading: true })),
    on(ScheduleActions.getSchedulesSuccess, (state, payload) => ({
        ...state,
        schedules: payload.schedules,
        schedulesLoading: false
    })),
    on(ScheduleActions.getSchedulesFailed, (state) => ({ ...state, schedulesLoading: false })),
    on(ScheduleActions.resetScheduleDialog, (state) => ({
        ...state, scheduleAdding: false, scheduleAdded: false, scheduleEditing: false, scheduleEdited: false
    })),
    on(ScheduleActions.addSchedule, (state) => ({ ...state, scheduleAdding: true, scheduleAdded: false })),
    on(ScheduleActions.addScheduleSuccess, (state, payload) => ({
        ...state,
        schedules: [...state.schedules, payload.schedule],
        scheduleAdding: false, scheduleAdded: true,
    })),
    on(ScheduleActions.addScheduleFailed, (state) => ({ ...state, scheduleAdding: true, scheduleAdded: false })),
    on(ScheduleActions.editSchedule, (state) => ({ ...state, scheduleEditing: true, scheduleEdited: false })),
    on(ScheduleActions.editScheduleSuccess, (state, payload) => {
        const schs = state.schedules.filter(sch => sch.Id !== payload.schedule.Id);
        return {
            ...state,
            schedules: [ ...schs, payload.schedule ],
            scheduleEditing: false, scheduleEdited: true,
        };
    }),
    on(ScheduleActions.editScheduleFailed, (state) => ({ ...state, scheduleEditing: true, scheduleEdited: false })),
    on(ScheduleActions.deleteScheduleSuccess, (state, payload) => ({
        ...state,
        schedules: state.schedules.filter(sch => sch.Id !== payload.scheduleId),
    })),
);

export const reducer = (state: State | undefined, action: Action): State => scheduleReducer(state, action);
